import Vue from 'vue';
import Vuex from 'vuex';

import dataloader from "@/api/dataloader";

Vue.use(Vuex);

let imageCounter = 0

export default new Vuex.Store({
    state: {
        // start out as 'loading' as it get stopped once we completed initialization
        loadingdata: true,
        userdata: {},
        eventlist: {},
    },
    getters: {
        getUserdata: state => { return (state.userdata) },
        getEventList: state => { return (state.eventlist) },
        isLoggedIn: state => { return (state.userdata.username !== undefined) },
        isLoading: state => { return (state.loadingdata) },
    },

    mutations: {
        setIsLoading(state, isLoading) {
            state.loadingdata = isLoading
        },
        setUserData(state, userdata) {
            if (userdata.error == true) {
                console.log("Error")
                return false
            }
            console.log("set userdata")
            console.log(JSON.stringify(userdata))
            state.userdata = JSON.parse(JSON.stringify(userdata))
        },
        setEventList(state, eventlist) {
            if (eventlist.error == true) {
                console.log("Error")
                return false
            }
            console.log("set eventlist")
            state.eventlist = JSON.parse(JSON.stringify(eventlist))
        },
    },
    // ***************************************************************************
    actions: {
        async onCreate() {
            await this.dispatch('getData')
        },
        async getData(context) {
            var result = await dataloader.getData("iap")
            console.log("get data:")
            console.log(JSON.stringify(result))
            context.commit('setEventList', { iap: result.event })
            imageCounter = imageCounter + 1
            let sFileName = "/k/api/signup/iap/image/" + imageCounter
            let userdata = { username: result.username, events: {}, content: {} }
            if ((result.registration !== undefined) && (result.registration.id !== undefined)) {
                userdata.events.iap = [result.registration.id]
                userdata.content.iap = sFileName
                if (result.registration.details !== undefined) {
                    userdata.message = result.registration.details.message
                } else {
                    userdata.message = undefined
                }
            }
            context.commit('setUserData', userdata)
        },
    },
});